class ShipFill {
	constructor() {
		this._init()
	}
	_init() {
		this.el = document.querySelector('[data-ship]')
		if(!this.el) {
			return
		}

		this.el.shipFill = this
		this.elInputs = this.el.querySelectorAll('[data-validator]')
		this.elValue = document.querySelector('[data-ship-value]')

		this.elAction = this.el.querySelector('[data-ship-action]')
		if(!this.elAction) {
			return
		}
		if(!this.el) {
			throw "Found no value for ShipFill"
		}
		this.elAction.addEventListener('click', () => this.updateValue())
	}
	updateValue() {
		const price = this.getPriceOfSelection()
		if(price == -1) {
			throw "None selected"
		}
		this.elValue.setAttribute('data-value', price)
	}
	getPriceOfSelection() {
		for (let i = 0; i < this.elInputs.length; i++) {
			if (this.elInputs[i].checked) {
				if ("" === this.elInputs[i].dataset.shipPrice) {
					return 0
				}
				return parseFloat(this.elInputs[i].dataset.shipPrice)
			}
		}
		return -1
	}
	getNewValue(index) {
		switch(index) {
			case 0:
				return 0
			case 1:
				return 2.99
			case 2:
				return 8.5
		}
	}
}

export default ShipFill